import React, { useState, useEffect } from 'react';
import { Container, TextField, Button, Typography, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Grid } from '@mui/material';

const FormularioMaquina = () => {
    const [machine, setMachine] = useState({
        machine: '',
        machineNumber: '',
        sensorNumber: '',
        dataToSense: '',
        notes: ''
    });
    const [machines, setMachines] = useState([]);

    useEffect(() => {
        const fetchMachines = async () => {
            const token = localStorage.getItem('token'); // Obtener el token de autenticación del almacenamiento local
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/machines`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}` // Incluir el token de autenticación en los encabezados
                    }
                });
                const data = await response.json();
                console.log('Respuesta del servidor:', data); // Agregar un console.log para verificar la respuesta del servidor
                if (Array.isArray(data)) {
                    setMachines(data);
                } else {
                    console.error('La respuesta del servidor no es un array:', data);
                }
            } catch (error) {
                console.error('Error al obtener las máquinas:', error);
            }
        };

        fetchMachines();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setMachine({
            ...machine,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token'); // Obtener el token de autenticación del almacenamiento local
        try {
            // Transformar dataToSense en array separando por comas
            const bodyToSend = {
                ...machine,
                dataToSense: typeof machine.dataToSense === 'string'
                    ? machine.dataToSense.split(',').map(s => s.trim()).filter(Boolean)
                    : machine.dataToSense
            };

            const response = await fetch(`${process.env.REACT_APP_API_URL}/machines`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` // Incluir el token de autenticación en los encabezados
                },
                body: JSON.stringify(bodyToSend)
            });
            if (response.ok) {
                alert('Máquina agregada exitosamente');
                setMachine({
                    machine: '',
                    machineNumber: '',
                    sensorNumber: '',
                    dataToSense: '',
                    notes: ''
                });
                const newMachine = await response.json();
                setMachines((prevMachines) => [...prevMachines, newMachine]); // Actualizar la lista de máquinas
            } else {
                alert('Error al agregar la máquina');
            }
        } catch (error) {
            console.error('Error al agregar la máquina:', error);
            alert('Error al agregar la máquina');
        }
    };

    const handleDelete = async (id) => {
        const confirmDelete = window.confirm('¿Estás seguro de que deseas eliminar esta máquina?');
        if (!confirmDelete) {
            return; // Cancelar la eliminación si el usuario no confirma
        }

        const token = localStorage.getItem('token'); // Obtener el token de autenticación del almacenamiento local
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/machines/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` // Incluir el token de autenticación en los encabezados
                }
            });
            if (response.ok) {
                alert('Máquina eliminada exitosamente');
                setMachines(machines.filter(machine => machine._id !== id)); // Actualizar la lista de máquinas
            } else {
                alert('Error al eliminar la máquina');
            }
        } catch (error) {
            console.error('Error al eliminar la máquina:', error);
            alert('Error al eliminar la máquina');
        }
    };

    return (
        <Container maxWidth="md">
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 6 }}>
                <Typography component="h1" variant="h5" gutterBottom>
                    Ingreso de Sensor
                </Typography>
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="machine"
                                label="Nombre de la Máquina"
                                name="machine"
                                autoComplete="machine"
                                autoFocus
                                value={machine.machine}
                                onChange={handleChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="machineNumber"
                                label="Número de la Máquina"
                                name="machineNumber"
                                autoComplete="machine-number"
                                value={machine.machineNumber}
                                onChange={handleChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="sensorNumber"
                                label="Número del Sensor"
                                name="sensorNumber"
                                autoComplete="sensor-number"
                                value={machine.sensorNumber}
                                onChange={handleChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="dataToSense"
                                label="Datos a Sensar (separados por comas)"
                                name="dataToSense"
                                autoComplete="data-to-sense"
                                value={machine.dataToSense}
                                onChange={handleChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                margin="normal"
                                fullWidth
                                id="notes"
                                label="Notas"
                                name="notes"
                                autoComplete="notes"
                                multiline
                                rows={4}
                                value={machine.notes}
                                onChange={handleChange}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Agregar Máquina
                    </Button>
                </Box>
            </Box>

            <Box sx={{ mt: 6 }}>
                <Typography component="h2" variant="h6" gutterBottom>
                    Lista de Máquinas
                </Typography>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Nombre de la Máquina</TableCell>
                                <TableCell>Número de la Máquina</TableCell>
                                <TableCell>Número del Sensor</TableCell>
                                <TableCell>Datos a Sensar</TableCell>
                                <TableCell>Notas</TableCell>
                                <TableCell>Acciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {machines.map((m) => (
                                <TableRow key={m._id}>
                                    <TableCell>{m.machine}</TableCell>
                                    <TableCell>{m.machineNumber}</TableCell>
                                    <TableCell>{m.sensorNumber}</TableCell>
                                    <TableCell>{Array.isArray(m.dataToSense) ? m.dataToSense.join(', ') : m.dataToSense}</TableCell>
                                    <TableCell>{m.notes}</TableCell>
                                    <TableCell>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => handleDelete(m._id)}
                                        >
                                            Eliminar
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Container>
    );
};

export default FormularioMaquina; 